import { Route } from '@angular/router';
import { DEMO_PATH, DEMO_TITLE } from '../../mgs-path-defs';
import { mgsExclusionRoleGuard } from '../../mgs-guards';
import {
  MgsRole,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_INSTAHELP,
  ROLE_MGS_KIDS,
  ROLE_MGS_PHARMAKOGENETIK,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';

export const dienstleistungDemoRolesForExclusion: MgsRole[] = [
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN,
  ROLE_MGS_INSTAHELP,
  ROLE_MGS_PHARMAKOGENETIK,
  ROLE_MGS_ABRECHNUNG
];

export const dienstleistungDemoRoute: Route = {
  path: DEMO_PATH,
  title: DEMO_TITLE,
  loadComponent: () => import('./dienstleistung-demo.component'),
  canActivate: [mgsExclusionRoleGuard(dienstleistungDemoRolesForExclusion)]
};
